export { wrapRootElement, wrapPageElement } from 'wrappers';

export const onServiceWorkerUpdateFound = () =>
  console.log('The application will be updated after next reload.');
